export const keys = {
  'en-us': {
    Malaysian: 'Malaysian',
    Foreigner: 'Foreigner',
    Adult: 'Adult',
    Kid: 'Kid',
    AdultOrKid: 'Adult/Kid',
    'D Tours: Sky Mirror': 'D Tours: Sky Mirror',
    'Mirror of Sky': 'Mirror of Sky',
    Rates: 'Rates',
    Combo: 'Combo',
    Packages: 'Packages',
    'Aged 2 - 11': 'Aged 2 - 11',
    RM: 'RM',
    'All Rights Reserved': 'All Rights Reserved',
    Reminders: 'Reminders',
    Menu: 'Menu',
    'Check here': 'Check here',
    Accomm: 'Accomm',
    'Bulk Discount': 'Promotion',
    'pax or above': 'pax or above',
    'Learn More': 'Learn More',
    Book: 'Book',
    pax: 'pax',
    Date: 'Date',
    Total: 'Total',
    Service: 'Service',
    Time: 'Time',
    Itinerary: 'Itinerary',
    'Sky Mirror Departure Time': 'Sky Mirror Departure Time',
    'Departure Time': 'Departure Time',
    'Choose a date to see departure time':
      'Choose a date to see departure time',
    Album: 'Album',
    'Previous Photo': 'Prev',
    'Next Photo': 'Next',
    Close: 'Close',
    itemSeparator: ', ',
    'Basic Info': 'Basic Info',
    'MCO Registration': 'MCO Registration',
    'Mobile Number': 'Mobile Number',
    'Full Name': 'Full Name',
    'MyKad/MyKid': 'MyKad/MyKid',
    'Passport Number': 'Passport Number',
    'Date of Birth': 'Date of Birth',
    Submit: 'Submit',
    'Details submitted successfully': 'Details submitted successfully',
  },
  'zh-sg': {
    Malaysian: '本地游客',
    Foreigner: '外国游客',
    Adult: '成人',
    Kid: '小孩',
    AdultOrKid: '成人/小孩',
    'D Tours: Sky Mirror': 'D Tours: 天空之镜',
    'Mirror of Sky': '天空之镜',
    Rates: '价格',
    Combo: '组合',
    Packages: '配套',
    'Aged 2 - 11': '2-11岁',
    RM: 'MYR',
    'All Rights Reserved': '版权所有',
    Reminders: '出发需知',
    Menu: '目录',
    'Check here': '查看这里',
    Accomm: '住宿',
    'Bulk Discount': '团购优惠',
    'pax or above': '人或以上',
    'Learn More': '了解更多',
    Book: '预定',
    pax: '人数',
    Date: '日期',
    Total: '总共',
    Service: '服务',
    Time: '时间',
    Itinerary: '行程',
    'Sky Mirror Departure Time': '天空之镜出发时间',
    'Departure Time': '出发时间',
    'Choose a date to see departure time': '选择日期以查看出发时间',
    Album: '图片库',
    'Previous Photo': '上一张',
    'Next Photo': '下一张',
    Close: '关闭',
    itemSeparator: '、',
    'Basic Info': '基本资料',
    'MCO Registration': '行动管制登记',
    'Mobile Number': '手机号码',
    'Full Name': '全名',
    'MyKad/MyKid': 'MyKad/MyKid',
    'Passport Number': '护照号码',
    'Date of Birth': '生日日期',
    Submit: '提交',
    'Details submitted successfully': '提交成功',
  },
};
